import React, { Component } from 'react';
import { Button, Avatar, Icon, Menu, Dropdown, Tag, message } from 'antd';
import { getUserRole, getUser, reInviteUser } from '../../utils/services/userAPI';
import { getGroupPermission } from '../../utils/services/teamsAPI';
import { getLdapConfigs } from '../../utils/services/ldapAPI';
import { fetchUserDetails } from '../../utils/services/authAPI';
import {
  DetailsCard,
  UserProfilecover,
  DropdownDetails,
  UserDetailHeadingCover,
  LoaderContainer,
  UserEditCover,
  UserDetails,
  RoleSection,
} from './styles';
import Loader from '../../components/Loader';
import AddUserModal from '../../components/Modals/AddUserModal';
import DeleteUserModal from '../../components/Modals/DeleteUserModal';
import { AppStoreContext } from '../../context/appStoreContext';
import LDAPConfigModal from '../../components/Modals/LDAPConfigModal';
import UpgradePlanModal from '../../components/Modals/UpgradePlanModal';

import { withTranslation } from 'react-i18next';
import { MANAGE_USERS as trans } from './TranslationValues';
import { SUPPORT_EMAIL_ID } from '../../utils/helper';
const NAMESPACES = ['MANAGE_USERS'];
const invitedUser = "invited";

const ROLES = (t) => [
	{ id: 3, name: t(trans.ADMIN_ROLE.key, trans.ADMIN_ROLE.value), color: 'green' },
	{ id: 4, name: t(trans.PUBLISHER_ROLE.key, trans.PUBLISHER_ROLE.value), color: 'orange' },
	{ id: 5, name: t(trans.DESIGNER_ROLE.key, trans.DESIGNER_ROLE.value), color: 'blue' },
	{ id: 6, name: t(trans.MAIL_ROOM_ADMIN_ROLE.key, trans.MAIL_ROOM_ADMIN_ROLE.value), color: 'purple' },
	{ id: 7, name: t(trans.MAIL_ROOM_CLIENT_ROLE.key, trans.MAIL_ROOM_CLIENT_ROLE.value), color: 'purple' },
	{ id: 8, name: t(trans.CONTACT_MANAGER_ROLE.key, trans.CONTACT_MANAGER_ROLE.value), color: 'red' },
	{ id: 9, name: t(trans.CAMPAIGN_MANAGER_ROLE.key, trans.CAMPAIGN_MANAGER_ROLE.value), color: 'red' },
	{ id: 10, name: t(trans.JOB_APPROVER_L1.key, trans.JOB_APPROVER_L1.value), color: 'cyan' },
	{ id: 11, name: t(trans.JOB_APPROVER_L2.key, trans.JOB_APPROVER_L2.value), color: 'cyan' },
	{ id: 12, name: t(trans.JOB_APPROVER_L3.key, trans.JOB_APPROVER_L3.value), color: 'cyan' },
	{ id: 13, name: t(trans.JOB_APPROVER_L4.key, trans.JOB_APPROVER_L4.value), color: 'cyan' },
	{ id: 14, name: t(trans.JOB_MANAGER.key, trans.JOB_MANAGER.value), color: 'cyan' },
  { id: 15, name: t(trans.WORKFLOW_MANAGER.key, trans.WORKFLOW_MANAGER.value), color: 'lime' },
  { id: 16, name: t(trans.ID_EDITOR.key, trans.ID_EDITOR.value), color: 'magenta' },
  { id: 17, name: t(trans.REUSABLE_CONTENT_MANAGER.key, trans.REUSABLE_CONTENT_MANAGER.value), color: 'geekblue' },
  { id: 18, name: t(trans.FORM_USER.key, trans.FORM_USER.value), color: 'volcano' },
  { id: 19, name: t(trans.HYBRID_ROLE.key, trans.HYBRID_ROLE.value), color: 'gold' },
]


class ManageUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: '',
      userRoleData: '',
      isLoading: true,
      modalVisible: false,
      currentUser: {},
      isEditable: false,
      deleteModalVisible: false,
      groupPermission: null,
      ldapConfigModalVisible: false,
      ldapDetails: '',
      userCount: 0,
      userLimit: 0,
      upgradeModal: false,
      isReInviting: false,
      isCheckingLimit: false,
    };
  }

  static contextType = AppStoreContext;

  async componentDidMount() {
    const { userDetails, isEnterprise, isLdapConfigured } = this.context;
    const { t } = this.props;
    const userType = userDetails.userType;
    let Userresponse = await getUser(userType);
    let UserRoleresponse = await getUserRole();
    let groupPermission = await getGroupPermission();
    let result = [];
    let rgIds = [];
    const userRoles = UserRoleresponse?.data?.map(role => {
      const updatedRole = ROLES(t).find(localized_role => role.id === localized_role.id);
      return {
        ...role,
        name: updatedRole ? updatedRole.name : role.name,
        color: updatedRole?.color ?? 'magenta',
      }
    });
    if (groupPermission?.data) {
      for (const data of groupPermission.data) {
        if (rgIds.includes(data.rgId)) {
          let target = result.find(a => a.rgid === data.rgId);
          if (target) {
            const permissionObj = {
              id: data.id,
              type: data.permission === 'read' ? 'Read Only' : 'Read, Write',
            };
            target.permission.push(permissionObj);
          }
        } else {
          let permission = [
            {
              id: data.id,
              type: data.permission === 'read' ? 'Read Only' : 'Read, Write',
            },
          ];
          const rgObject = {
            rgid: data.rgId,
            groupName: data.groupName,
            permission,
          };
          rgIds.push(data.rgId);
          result.push(rgObject);
        }
      }
    }
    if(isEnterprise && isLdapConfigured) {
      let ldapresponse = await getLdapConfigs();
      if (ldapresponse && ldapresponse.errors && ldapresponse.errors.length === 0) {
      this.setState({
        ldapDetails: ldapresponse.data,
      });
    }
    }
    this.setState({
      userData: Userresponse?.data,
      userRoleData: userRoles,
      isLoading: false,
      groupPermission: result,
      userCount: Userresponse.dataCount,
      userLimit: userDetails.planMapping.user ? userDetails.planMapping.user : null,
    });
  }

  showModal = () => {
    this.setState({
      modalVisible: true,
      isEditable: false,
      currentUser: {},
    });
  };

  handleDeleteUser = currentUser => {
    this.setState({
      currentUser,
      deleteModalVisible: true,
    });
  };

  handleEditUser = currentUser => {
    this.setState({
      currentUser,
      isEditable: true,
      modalVisible: true,
    });
  };

  handleDeleted = isDeleted => {
    const { currentUser, userData } = this.state;
    if (isDeleted) {
      let id = currentUser.id;
      let filterdata = userData.filter(user => {
        return id !== user.id;
      });
      this.setState({
        userData: filterdata,
        userCount: this.state.userCount - 1,
      });
    }
    this.setState({
      deleteModalVisible: false,
    });
  };

  handleLdapModal = ldapConfigData => {
    this.setState({
      ldapConfigModalVisible: false,
      ldapDetails: ldapConfigData,
    });
  };

  onSuccess = async (status, responseId, payload) => {
    const { userData } = this.state;
    switch (status) {
      case 'LDAP_User_Added':       
        this.setState({
          userData: [...userData, payload],
          modalVisible: false,
        });
        break;
      case 'Added':
        const userType = this.context.userDetails.userType;
        let Userresponse = await getUser(userType);
        let adduserData = Userresponse?.data;
        this.setState({
          userData: adduserData,
          modalVisible: false,
          userCount: Userresponse.dataCount,
        });
        break;
      case 'Updated':
        let elementsIndex = userData.findIndex(value => value.id === responseId);
        let newUpadatedUserData = userData;
        newUpadatedUserData[elementsIndex] = payload;
        this.setState({
          userData: newUpadatedUserData,
          modalVisible: false,
        });
        break;
      default:
        this.setState({
          modalVisible: false,
          deleteModalVisible: false,
        });
    }
  };

  handleInviteUser = async () => {
    const { isEnterprise, setUserDetails, checkUserAccess } = this.context;
    const { t } = this.props;
    if(isEnterprise || checkUserAccess('master')) {
      this.showModal();
      return;
    }
    const { userCount } = this.state;    
    this.setState({ isCheckingLimit: true });
    const response = await fetchUserDetails();
    if(response && response.statusCode === 1903 && response.errors && response.errors.length === 0) {
      setUserDetails(response.data);
      const { user, planName } = response.data.planMapping;
      this.setState({ userLimit: user ? user : null, isCheckingLimit: false });
      if(user) {
        if(userCount < user) {
          this.showModal();
        } else {
          this.setState({ upgradeModal: true });
        }
      } else {
        user === null && this.showModal();
      }
    } else {
      this.setState({ isCheckingLimit: false });
      message.error(t(trans.ERROR_CHECKING_USER_LIMIT.key, trans.ERROR_CHECKING_USER_LIMIT.value));
    }    
  }

  handleReInviteUser = async (id) => {
    const { t } = this.props;
    this.setState({ isReInviting: true });
    let response = await reInviteUser(id);
    if (response && response.statusCode === 1907 && response.errors && response.errors.length === 0) {
      this.setState({ isReInviting: false });
      message.success(t(trans.REINVITE_SUCCESS_MESSAGE.key, trans.REINVITE_SUCCESS_MESSAGE.value));
    } else {
      this.setState({ isReInviting: false });
    }
  }

  render() {
    const {
      userData,
      isLoading,
      modalVisible,
      isEditable,
      userRoleData,
      currentUser,
      deleteModalVisible,
      groupPermission,
      ldapConfigModalVisible,
      ldapDetails,
      userLimit,
      isReInviting,
      isCheckingLimit,
    } = this.state;
    const { checkUserAccess, userDetails, isEnterprise } = this.context;
    const { t } = this.props;
    const userLang = userDetails.languageCode;
    const planName = userDetails.planMapping.planName;
    return (
      <React.Fragment>
        {isLoading ? (
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        ) : (
          <>
            <UserDetailHeadingCover>
              <div>
                <h5>{t(trans.MANAGE_USERS_TITLE.key, trans.MANAGE_USERS_TITLE.value)}</h5>
                <p>{t(trans.MANAGE_USERS_DESCRIPTION.key, trans.MANAGE_USERS_DESCRIPTION.value)}</p>
                {isEnterprise && checkUserAccess('client') && (
                  <div
                    className="ldap_config"
                    onClick={() => this.setState({ ldapConfigModalVisible: true })}
                  >
                    <p>{ldapDetails?.ldapConfigured ? t(trans.EDIT_CONFIGURATION_BUTTON.key, trans.EDIT_CONFIGURATION_BUTTON.value) : t(trans.CONFIGURE_LDAP_BUTTON.key,trans.CONFIGURE_LDAP_BUTTON.value)}</p>
                    <Icon type={ldapDetails?.ldapConfigured ? 'edit' : 'plus'} />
                  </div>
                )}
              </div>
                <Button type="primary" className="add_user_btn" loading={isCheckingLimit} onClick={() => this.handleInviteUser()}>
                  { isCheckingLimit ? t(trans.PLEASE_WAIT_BUTTON.key, trans.PLEASE_WAIT_BUTTON.value)
                  : t(trans.INVITE_USER_BUTTON.key, trans.INVITE_USER_BUTTON.value)}
                </Button>
            </UserDetailHeadingCover>
            <div className="card_cover_div">
              {userData &&
                userData.map((value, key) => {
                  return (
                    <DetailsCard key={key} user={true}>
                      <UserProfilecover>
                        <Avatar className="avatar">
                          {value.aType === 'ad'
                            ? value.displayName?.charAt(0).toUpperCase()
                            : value.firstName?.charAt(0).toUpperCase()}
                        </Avatar>
                        <UserDetails>
                          {value.aType === 'ad' ? (
                            <p>{value.displayName}</p>
                          ) : (
                            <p>
                              {(value.firstName !== null ? value.firstName : '') +
                                ' ' +
                                (value.lastName !== null ? value.lastName : '')}
                            </p>
                          )}
                          <RoleSection>
                            {userRoleData.map((role, key) => {
                              if (value.roles.includes(role.id)) {
                                return (
                                  <Tag key={key} color={role.color}>{role.name.toUpperCase()}</Tag>
                                );
                              }
                            })}
                          </RoleSection>
                        </UserDetails>
                      </UserProfilecover>
                      <UserEditCover>
                        <div className="mailId">{value.aType === 'ad' ? '' : value.email}</div>
                        <div className="user_type">
                          {value.primary && (
                            <Tag color="#108ee9">
                              <Icon type="user" />
                              {t(trans.PRIMARY_TAG.key, trans.PRIMARY_TAG.value)}
                            </Tag>
                          )}
                          {value.userType === 'master' && (
                            <Tag color="#ad077e">
                              <Icon type="star" />
                              {t(trans.MASTER_TAG.key, trans.MASTER_TAG.value)}
                            </Tag>
                          )}
                        </div>

                        <div style={{ position: 'relative' }}>
                        {!(checkUserAccess('client') && value.userType === 'master') && 
                            <DropdownDetails
                              id={`${value.id}-user`}
                              className="dropdown-menu"
                              onClick={e => e.stopPropagation()}
                              trigger={['click']}
                            >
                              <Dropdown
                                overlay={
                                  <Menu>
                                      <Menu.Item key="0" onClick={() => this.handleEditUser(value)}>
                                      {t(trans.EDIT_USER_OPTION.key, trans.EDIT_USER_OPTION.value)}
                                      </Menu.Item>
                                      <Menu.Item
                                        key="1"
                                        onClick={() => {
                                          value.primary ? 
                                            message.error(t(trans.PRIMARY_USER_DELETE_ERROR.key, trans.PRIMARY_USER_DELETE_ERROR.value)) 
                                            : this.handleDeleteUser(value)
                                        }}
                                      >
                                        {t(trans.DELETE_USER_OPTION.key, trans.DELETE_USER_OPTION.value)}
                                      </Menu.Item>
                                      {value.status === invitedUser &&
                                        <Menu.Item key="2" onClick={() => this.handleReInviteUser(value.id)}>
                                          {t(trans.RESEND_INVITE_BUTTON.key, trans.RESEND_INVITE_BUTTON.value)}
                                        </Menu.Item>}
                                  </Menu>
                                }
                                trigger={['click']}
                                getPopupContainer={() =>
                                  document.getElementById(`${value.id}-user`)
                                }
                              >
                                <Icon type="more" />
                              </Dropdown>
                            </DropdownDetails>
                        }
                        </div>
                      </UserEditCover>
                    </DetailsCard>
                  );
                })}
            </div>
          </>
        )}
        {isReInviting && 
          message.loading(t(trans.RESENDING_INVITE_MESSAGE.key, trans.RESENDING_INVITE_MESSAGE.value))}
        {modalVisible && (
          <AddUserModal
            visible={modalVisible}
            onCancel={this.onSuccess}
            targetUser={currentUser}
            isEditable={isEditable}
            userRoleData={userRoleData}
            groupPermission={groupPermission}
            isInitialLDAPConfig={!ldapDetails?.ldapConfigured}
          />
        )}
        {deleteModalVisible && (
          <DeleteUserModal
            visible={deleteModalVisible}
            targetUser={currentUser}
            onCancel={this.handleDeleted}
          />
        )}
        {ldapConfigModalVisible && (
          <LDAPConfigModal
            visible={ldapConfigModalVisible}
            onCancel={this.handleLdapModal}
            ldapDetails={ldapDetails}
          />
        )}
        {this.state.upgradeModal && (
          <UpgradePlanModal
          visible={this.state.upgradeModal}
          modalText={planName ==='Premium' ? 
            t(trans.PREMIUM_USER_LIMIT_REACHED.key, trans.PREMIUM_USER_LIMIT_REACHED.value, { emailId: SUPPORT_EMAIL_ID })
          : planName === 'Free' ? 
            t(trans.FREE_PLAN_UPGRADE_MESSAGE.key, trans.FREE_PLAN_UPGRADE_MESSAGE.value, { userCount: userLimit }) 
          : t(trans.STANDARD_PLAN_UPGRADE_MESSAGE.key, trans.STANDARD_PLAN_UPGRADE_MESSAGE.value, { userCount: userLimit })}
          onCancel={() => {
            this.setState({ upgradeModal: false })}}  
          />
        )}
      </React.Fragment>
    );
  }
}
export default withTranslation(NAMESPACES)(ManageUsers);
